import { useState, useEffect, Fragment } from "react";
import { View, StyleSheet, Text } from 'react-native';
import Modal from "react-modal";

import { ReactComponent as CloseButtonImg } from "../../../img/btn-close-white.svg";

import { FONT } from "../../../value/staticValues";
import { EDIT_POPUP_TYPE } from "../../../value/type";

import { useTranslation } from "react-i18next";
import { TextArea } from "../CustomInputText";
import { CustomCancelBtn } from "../CustomCancelBtn";
import { CustomConfirmBtn } from "../CustomConfirmBtn";

const editPopupModalStyle = {
	content: {
		maxHeight: "100%",
		overflow: "hidden",
		top: "43%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		border: "0px",
		padding: "0px",
		transform: "translate(-50%, -50%)",
		backgroundColor: "transparent",
        zIndex: 13,
		borderRadius: "12px",
	},
    overlay: {
		backgroundColor: "rgba(0, 0, 0, 0.6)"
	},
};

export interface CashCancelType {
	serviceName: string;
	chargeMethodType: string;
	paymentAmount: string;
	cancelAmount: string;
	chargeType: string;
	cancelYn: boolean;
}

export interface EditPopupModalContentType {
	openYn: boolean;
	type: string;
	title?: string;
	message?: string;
	value?: string;
	placeHolder?: string;
	code?: string;
	id?: string;
	cancelButtonYn: boolean;
	confirmButtonCb?: Function;
	deleteYn?: boolean;
	cashCancelData?: CashCancelType;
}


interface EditPopupModalProps {
	showLoadingCb: Function;
	showEditPopupModalCb: Function;
	content: EditPopupModalContentType;
}

export default function EditPopupModal(props: EditPopupModalProps){
    const { t } = useTranslation();
	const [topContainerStyle, setTopContainerStyle] = useState(style.topContainer);
	const [closeButtonHoverYn, setCloseButtonHoverYn] = useState(false);
	const [editValue, setEditValue] = useState("");
	const [openYn, setOpenYn] = useState(false);
	const [editWarnYn, setEditWarnYn] = useState(false);
	


	useEffect(() => {
		setOpenYn(props.content.openYn);
		if(!props.content.openYn) {
			//init
			setCloseButtonHoverYn(false);
		} else {
			if(props.content.type === EDIT_POPUP_TYPE.TEXT_AREA_SEND_EDIT_POPUP) {
				setTopContainerStyle(style.topContainer);
			} else {
				setTopContainerStyle(style.topContainer);
			}
		}
		if(props.content.value) {
			setEditValue(props.content.value);
		}
		setEditWarnYn(false);
	}, [props]);


	useEffect(() => {
		setEditWarnYn(false);
	}, [editValue]);


	function closeModal() {
		setEditValue("");
		setEditWarnYn(false);
		props.showEditPopupModalCb(EditPopupModal.defaultProps);
		
	}

	function confirmModal(code) {
		if(props.content.confirmButtonCb) {
			if(code === "DELETE") {
				props.content.confirmButtonCb(props.content.id, code, "");
			} else if(code === "ADD" || code === "UPDATE") {
				if(!editValue) {
					setEditWarnYn(true);
					return ;
				} else {
					props.content.confirmButtonCb(props.content.id, code, editValue);
				}
			} else if(code === "CANCEL" || code === "REFUND") {
				props.content.confirmButtonCb(props.content.id, code, editValue);
			}
		}
		closeModal();
	}


    return (
        <Modal
		isOpen={props.content.openYn}
		style={editPopupModalStyle}
		contentLabel={"editPopup"}
		ariaHideApp={false}
		>
			<View style={topContainerStyle}>
				<View style={style.mainContainer}>
					<Fragment>
						<View style={style.titleContainer}>
							<Text style={style.titleText}>{props.content.title}</Text>
							<CloseButtonImg
							onMouseOver={(e) => {setCloseButtonHoverYn(true);}}
							onMouseOut={(e) => {setCloseButtonHoverYn(false);}}
							onClick={(e) => {closeModal();}}
							style={closeButtonHoverYn ? className.titleCloseButtonImgHover : className.titleCloseButtonImg}/>
						</View>
						{
							props.content.type === EDIT_POPUP_TYPE.TEXT_AREA_SEND_EDIT_POPUP ?
							<Fragment>
								<View style={style.messageContainer}>
									<Text style={style.messageText}>{props.content.message}</Text>
									{
										props.content.value ? 
                                            <div 
                                                style={className.deleteTextContainer}
                                                onClick={(e)=>confirmModal("DELETE")}
                                            >
                                                {t("DELETE_TEXT")}
                                            </div> 
										: null
									}
								</View>
								<TextArea 
                                        key={2}
                                        width={505}
                                        height={180}
                                        value={editValue}
                                        type={"text"}
                                        activeYn={true}
                                        inputCb={setEditValue}
                                        warnYn={editWarnYn}
                                        maxLength={250}
                                        placeHolderText={props.content.placeHolder ? props.content.placeHolder : ""}
									/>
								<View style={style.textCounterContainer}>
									<Text style={style.textCounterValue}>{editValue.length}</Text>
									<Text style={style.textCounterText}> / 250</Text>
								</View>
							</Fragment>
							: null
						}
					</Fragment>
				</View>
				<View style={props.content.type === EDIT_POPUP_TYPE.TEXT_AREA_SEND_EDIT_POPUP ? style.buttonDivContainer: style.buttonDivWithDescriptionContainer}></View>
				<View style={style.buttonContainer}>
					<View style={style.cancelButtonContainer}>
						{
							//취소 버튼 추가
							openYn && props.content.cancelButtonYn ? 
                            <CustomCancelBtn 
                                text={t("CANCEL_TEXT")} 
                                onPress={closeModal}
                                disabled={true} 
                                size={{width: 44, height: 10}}
                            /> 
                            : null
						}
					</View>
					<View style={style.confirmButtonContainer}>
						{
							openYn ? 
								props.content.type === EDIT_POPUP_TYPE.TEXT_AREA_SEND_EDIT_POPUP ?
								<CustomConfirmBtn 
                                    text={props.content.value ? t("SAVE_TEXT") : t("REGISTER_TEXT")}
                                    onPress={(e)=>{confirmModal(props.content.value ? "UPDATE" : "ADD")}}
                                    disabled={true} 
                                    size={{width: 44, height: 10}}
                                />
								: null
							: null
						}
					</View>
				</View>
			</View>
		</Modal>
    )
}

EditPopupModal.defaultProps = {
	content: {
		openYn: false,
		cancelButtonYn: false,
	}
};

const style = StyleSheet.create({
	topContainer: {
		width: 600,
		minHeight: 600,
		padding: 40,
		backgroundColor: "#fff"
	},
	topCashCancelContainer: {
		width: 600,
		minHeight: 480,
		padding: 40,
		backgroundColor: "#fff"
	},
	mainContainer: {
		zIndex: 2,
	},
	titleContainer: {
		flexDirection: "row",
		alignItems: "center",

	},
	titleText: {
		marginTop: 0,
		fontFamily: FONT.MEDIUM,
		fontSize: 18,
		fontWeight: "500",
		color: "#333"
	},

	messageContainer: {
		marginTop: 32,
		marginBottom: 24,
		flexDirection: "row",
		alignItems: "center",
	},
	messageText: {
		fontFamily: FONT.REGULAR,
		fontSize: 14,
		color: "#333",
	},
	infoMessageContainer: {
		width: 520,
		flexDirection: "row",
	},
	infoMessageText: {
		marginLeft: 5,
		fontFamily: FONT.REGULAR,
		fontSize: 13,
		color: "#333",
	},
	infoMessageCountText: {
		marginHorizontal: 5,
		fontFamily: FONT.MEDIUM,
		fontSize: 20,
		fontWeight: "500",
		color: "#323ebd",
	},
	buttonDivContainer: {
		marginTop: 40,
		borderStyle: "solid",
		borderTopColor: "#eee",
		borderTopWidth: 1,
	},
	buttonDivWithDescriptionContainer: {
		marginTop: 14,
		borderStyle: "solid",
		borderTopColor: "#eee",
		borderTopWidth: 1,
	},
	buttonContainer: {
		flexDirection: "row",
		marginTop: 20,
		marginRight: 20,
		zIndex: 1,

	},
	cancelButtonContainer: {
		marginLeft: "auto",
		marginRight: 10,
	},
	confirmButtonContainer: {
		
	},
	textCounterContainer: {
		flexDirection: "row",
		alignItems: "center",
		marginLeft: "auto",
	},
	textCounterValue: {
		fontFamily: FONT.MEDIUM,
		fontSize: 11,
		fontWeight: "500",
		color: "#7b7d80"
	},
	textCounterText: {
		fontFamily: FONT.REGULAR,
		fontSize: 11,
		color: "#b9bcbf"
	},
	cashInfoContainer: {
		marginTop: 46
	},
	cashInfoRowContainer: {
		flexDirection: "row",
		alignItems: "center",
		height: 33,
		marginBottom: 5,
	},
	editTextRowContainer: {
		flexDirection: "row",
	},
	cashInfoRowText: {
		width: 130,
		fontFamily: FONT.REGULAR,
		fontSize: 13,
		color: "#333"
	},
	editTextRowText: {
		width: 130,
		marginTop: 10,
		fontFamily: FONT.REGULAR,
		fontSize: 13,
		color: "#333"
	},
	cashInfoRowServiceValue: {
		fontFamily: FONT.MEDIUM,
		fontWeight: "500",
		fontSize: 14,
		color: "#0853fb"
	},
	cashInfoRowMethodValue: {
		fontFamily: FONT.MEDIUM,
		fontWeight: "500",
		fontSize: 14,
		color: "#333"
	},
	cashInfoRowAmountValue: {
		fontFamily: FONT.MEDIUM,
		fontWeight: "500",
		fontSize: 18,
		color: "#494a4d"
	},

    cashInfoRowPeriodMonthlyContainer: {
        width: 50,
        height: 20,
        borderRadius: 10,
        borderStyle: "solid",
		borderWidth: 1,
		borderColor: "#67caca",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
	},
	cashInfoRowPeriodMonthlyValue: {
        fontFamily: FONT.MEDIUM,
        fontWeight: "500",
        fontSize: 10,
        color: "#67caca",
        overflow: "hidden",
    },
	cashInfoRowPeriodOnceContainer: {
        width: 50,
        height: 20,
        borderRadius: 10,
        borderStyle: "solid",
		borderWidth: 1,
		borderColor: "#77a9e3",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
	},
	cashInfoRowPeriodOnceValue: {
        fontFamily: FONT.MEDIUM,
        fontWeight: "500",
        fontSize: 10,
        color: "#77a9e3",
        overflow: "hidden",
    },
	cashDescriptionContainer: {
		width: 480,
		height: 40,
		marginLeft: 20,
		marginTop: 80,
		flexDirection: "row",
		alignItems: "center",
		paddingLeft: 10,
		borderRadius: 2,
		backgroundColor: "#f3f7ff"
	},

	cashDescriptionText: {
		fontFamily: FONT.REGULAR,
		fontSize: 12,
		color: "#323ebd"
	}
});

const className = {
	infoMessageImg: {
		marginTop: 7,
	},
	titleCloseButtonImg: {
		width: "28px",
		height: "28px",
		marginLeft: "auto",
		boxShadow: "none",
		cursor: "pointer"
	},
	titleCloseButtonImgHover: {
		width: "28px",
		height: "28px",
		marginLeft: "auto",
		boxShadow: "none",
		cursor: "pointer"
	},
	deleteTextContainer: {
		fontFamily: FONT.REGULAR,
		fontSize: "13px",
		color: "#8c9299",
		textDecorationLine: "underline",
		marginLeft: "auto",
		cursor: "pointer",
	},
	cashDescriptionImg: {
		width: "20px",
		height: "20px",
		marginRight: "14px"
	},
}